export default __webpack_public_path__ + "static/media/Group-105-2.0618617e.png";